import styled from '@emotion/styled';

export const SadaApplicant = styled.div``;
